export enum StepPanelEnums {
    PanelOne = 1,
    PanelTwo = 2,
    PanelThree = 3
}